// React things
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "./LeaderBoard.module.css";

// Downloads files
import _1st_place from "/1st-place.png";
import _2nd_place from "/2nd-place.png";
import _3rd_place from "/3rd-place.png";
import info_icon from "/info-icon.svg";
import leaders from "/leaders.png";
import tether_green from "/tether-green.png";

// Stores
import useApplicationSettings from "../../../Store/ApplicationSettings.js";
import useUserStore from "../../../Store/UserStore.js";

// Services
import {
	getBalance,
	getLeaders,
	getLeadersUSDT,
	getPositionInLeaderList,
} from "../../../Services/Requests.ts";

// Components
import LeaderboardUser from "../../../Components/LeaderboardUser/LeaderboardUser.jsx";
import MessageTip from "../../../Components/InfoTip/components/MessageTip/MessageTip.jsx";
import RewardLeaderBoard from "../../../Components/RewardLeaderBoard/RewardLeaderBoard.jsx";
import RewardTypeFilter from "../../../Components/RewardTypeFilter/RewardTypeFilter.jsx";
import TimeFilter from "../../../Components/TimeFilter/TimeFilter.jsx";
import EventableArea from "../../../Components/InfoTip/components/TipProvider/EventableArea.jsx";
import TipProvider from "../../../Components/InfoTip/components/TipProvider/TipProvider.jsx";
import LoadingWrapper from "../../../ComponentsWrappers/LoadingWrapper.jsx";
import { InfoTip } from "../../../Components/InfoTip/InfoTip";
// import MaintenancePage from '../../../Components/MaintenancePage/MaintenancePage.jsx'
const tg = window.Telegram.WebApp;

export default function LeaderBoard(props) {
	// To redraw rive component
	const [localizationKey, setLocalizationKey] = useState(0);

	// ApplicationSettings
	const setShowMenubar = useApplicationSettings(state => state.setShowMenubar);
	const localization = useApplicationSettings(state => state.localization);
	const leaderBoardRewardType = useApplicationSettings(
		state => state.leaderBoardRewardType
	);

	const [leaderBoardTimeFilter, setLeaderBoardTimeFilter] = useState("month");
	// UserStore
	const balance = useUserStore(state => state.balance);

	const [leadersList, setLeadersList] = useState({});
	const [leadersListUSDT, setLeadersListUSDT] = useState({});

	const [leaderUser, setLeaderUser] = useState({});
	const [leaderUserUSDT, setLeaderUserUSDT] = useState({});

	// const [ showTip, setShowTip ] = useState(false)

	const navigate = useNavigate();

	useEffect(() => {
		tg.BackButton.onClick(() => {
			navigate("/profile");
		});
		tg.BackButton.show();
		setShowMenubar(false);
		getLeaders(setLeadersList);
		getBalance(tg.initDataUnsafe.user.id);
		getPositionInLeaderList(setLeaderUser);
		getLeadersUSDT(setLeadersListUSDT, setLeaderUserUSDT);

		return () => {
			setShowMenubar(true);
		};
	}, []);
	useEffect(() => {
		setLocalizationKey(perv => perv + 1);
	}, [localization]);

	useEffect(() => {
		if (leaderBoardRewardType === "earned") {
			setLeaderBoardTimeFilter("month");
		}
	}, [leaderBoardRewardType]);

	return (
		<div className={style["container"]}>
			<div className={style["shadow"]}></div>
			<div className={style["container-wrapper"]}>
				<div className={style["title"]}>
					{localization["profilePage_loaderBoardPage_title"]}
				</div>
				<div className={style["reward-filter-wrapper"]}>
					<LoadingWrapper>
						<RewardTypeFilter key={localizationKey} />
					</LoadingWrapper>
				</div>
				<div className={style["leaders_timefilter-wrapper"]}>
					{leaderBoardRewardType === "farmed" && (
						<LoadingWrapper>
							<TimeFilter
								key={localizationKey}
								setLeaderBoardTimeFilter={setLeaderBoardTimeFilter}
							/>
						</LoadingWrapper>
					)}
					{leaderBoardRewardType == "farmed" && (
						<div className={style["reward-tips"]}>
							<InfoTip
								image={
									<img className={style["info-icon"]} src={info_icon}></img>
								}
							>
								<RewardLeaderBoard />
							</InfoTip>
						</div>
					)}
				</div>
				<RatingList
					leaderUser={
						leaderBoardRewardType == "farmed"
							? {
									position:
										leaderBoardTimeFilter == "month"
											? leaderUser?.month
											: leaderUser?.all_time,
									reward:
										leaderBoardTimeFilter == "month"
											? leaderUser?.total_farm_month
											: leaderUser?.total_farm_all,
							  }
							: {
									position: leaderUserUSDT?.all_time,
									reward: leaderUserUSDT?.total_farm_all,
							  }
					}
					leadersList={
						leaderBoardRewardType == "farmed"
							? leadersList[leaderBoardTimeFilter]
							: leadersListUSDT["alltime"]
					}
					isUSDT={leaderBoardRewardType == "earned" && true}
				/>
			</div>
		</div>
	);
}

function RatingList(props) {
	let { leaderUser, leadersList, isUSDT } = props;
	console.log(leadersList);

	const getInitial = name => {
		return name ? name.charAt(0).toUpperCase() : "?";
	};

	return (
		<>
			{leadersList && leaderUser ? (
				<div className={style["leaders"]}>
					<div className={style["top3"]}>
						<img className={style["top3-background"]} src={leaders} />
						<div className={style["top3-wrapper"]}>
							<div className={`${style["place-3"]} ${style["top-place"]}`}>
								{leadersList[1]?.photo_url ? (
									<img
										className={style["top-place-avatar"]}
										src={leadersList[1]?.photo_url}
									/>
								) : (
									<div className={style["top-place-avatar-fallback"]}>
										{getInitial(leadersList[1]?.name)}
									</div>
								)}
								<img className={style["place"]} src={_2nd_place} />
								<div className={style["username"]}>{leadersList[1]?.name}</div>
								<div className={style["reward"]}>
									{isUSDT && (
										<img className={style["coin-icon"]} src={tether_green} />
									)}
									{parseFloat(
										parseFloat(leadersList[1]?.total_farm)?.toFixed?.(2)
									).toString()}{" "}
									{isUSDT ? "USDT" : "DC"}
								</div>
							</div>
							<div className={`${style["place-1"]} ${style["top-place"]}`}>
								{leadersList[0]?.photo_url ? (
									<img
										className={style["top-place-avatar"]}
										src={leadersList[0]?.photo_url}
									/>
								) : (
									<div className={style["top-place-avatar-fallback"]}>
										{getInitial(leadersList[0]?.name)}
									</div>
								)}
								<img className={style["place"]} src={_1st_place} />
								<div className={style["username"]}>{leadersList[0]?.name}</div>
								<div className={style["reward"]}>
									{isUSDT && (
										<img className={style["coin-icon"]} src={tether_green} />
									)}
									{parseFloat(
										parseFloat(leadersList[0]?.total_farm)?.toFixed?.(2)
									).toString()}{" "}
									{isUSDT ? "USDT" : "DC"}
								</div>
							</div>
							<div className={`${style["place-2"]} ${style["top-place"]}`}>
								{leadersList[2]?.photo_url ? (
									<img
										className={style["top-place-avatar"]}
										src={leadersList[2]?.photo_url}
									/>
								) : (
									<div className={style["top-place-avatar-fallback"]}>
										{getInitial(leadersList[2]?.name)}
									</div>
								)}
								<img className={style["place"]} src={_3rd_place} />
								<div className={style["username"]}>{leadersList[2]?.name}</div>
								<div className={style["reward"]}>
									{isUSDT && (
										<img className={style["coin-icon"]} src={tether_green} />
									)}
									{parseFloat(
										parseFloat(leadersList[2]?.total_farm)?.toFixed?.(2)
									).toString()}{" "}
									{isUSDT ? "USDT" : "DC"}
								</div>
							</div>
						</div>
					</div>
					<div className={style["top"]}>
						{leadersList.map((element, index) => {
							if (index > 2) {
								return (
									<LeaderboardUser
										position={++index}
										img={element.photo_url}
										name={element.name}
										reward={parseFloat(
											parseFloat(element?.total_farm)?.toFixed?.(2)
										).toString()}
										borderbottom={true}
										defaultcolor={true}
										usdt={isUSDT}
									/>
								);
							}
						})}
					</div>
					<div className={style["you"]}>
						<LeaderboardUser
							position={leaderUser?.position}
							img={tg.initDataUnsafe.user.photo_url}
							name={tg.initDataUnsafe.user.first_name}
							reward={parseFloat(
								parseFloat(leaderUser?.reward)?.toFixed?.(2)
							).toString()}
							bordertop={true}
							yourcolor={true}
							usdt={isUSDT}
						/>
					</div>
				</div>
			) : (
				// isUSDT ?
				//     (<div className={style['leaders']}>
				//     <div className={style['top3']}>
				//         <img className={style['top3-background']} src={leaders}/>
				//         <div className={style['top3-wrapper']}>
				//             <div className={`${style['place-3']} ${style['top-place']}`}>
				//                 <img className={style['top-place-avatar']} src={`https://dreamcoin.pro/images/users/${leadersList[1]?.user_id}.jpg`}/>
				//                 <img className={style['place']} src={_2nd_place}/>
				//                 <div className={style['username']}>{leadersList[1]?.name}</div>
				//                 <div className={style['reward']}><img className={style['coin-icon']} src={tether_green}/> {parseFloat(leadersList[1]?.total_farm.toString())} USDT</div>
				//             </div>
				//             <div className={`${style['place-1']} ${style['top-place']}`}>
				//                 <img className={style['top-place-avatar']} src={`https://dreamcoin.pro/images/users/${leadersList[0]?.user_id}.jpg`}/>
				//                 <img className={style['place']} src={_1st_place}/>
				//                 <div className={style['username']}>{leadersList[0]?.name}</div>
				//                 <div className={style['reward']}><img className={style['coin-icon']} src={tether_green}/> {parseFloat(leadersList[0]?.total_farm.toString())} USDT</div>
				//             </div>
				//             <div className={`${style['place-2']} ${style['top-place']}`}>
				//                 <img className={style['top-place-avatar']} src={`https://dreamcoin.pro/images/users/${leadersList[2]?.user_id}.jpg`}/>
				//                 <img className={style['place']} src={_3rd_place}/>
				//                 <div className={style['username']}>{leadersList[2]?.name}</div>
				//                 <div className={style['reward']}><img className={style['coin-icon']} src={tether_green}/> {parseFloat(leadersList[2]?.total_farm.toString())} USDT</div>
				//             </div>
				//         </div>
				//     </div>
				//     <div className={style['top']}>
				//         {leadersList.map((element, index) => {
				//             if(index > 2){
				//                 return(
				//                     <LeaderboardUser position={++index} img={`https://dreamcoin.pro/images/users/${element.user_id}.jpg`} name={element.name} reward={parseFloat(element?.total_farm.toString())} borderbottom={true} defaultcolor={true} usdt={true}/>
				//                 )
				//             }
				//         })}
				//     </div>
				//     <div className={style['you']}>
				//         <LeaderboardUser position={leaderUser?.position} img={`https://dreamcoin.pro/images/users/${tg.initDataUnsafe.user.id}.jpg`} name={tg.initDataUnsafe.user.first_name} reward={parseFloat(leaderUser?.reward.toString())} bordertop={true} yourcolor={true} usdt={true}/>
				//     </div>
				// </div>  )

				// :
				//     <div className={style['leaders']}>
				//     <div className={style['top3']}>
				//         <img className={style['top3-background']} src={leaders}/>
				//         <div className={style['top3-wrapper']}>
				//             <div className={`${style['place-3']} ${style['top-place']}`}>
				//                 <img className={style['top-place-avatar']} src={`https://dreamcoin.pro/images/users/${leadersList[1]?.user_id}.jpg`}/>
				//                 <img className={style['place']} src={_2nd_place}/>
				//                 <div className={style['username']}>{leadersList[1]?.name}</div>
				//                 <div className={style['reward']}>{Math.floor(leadersList[1]?.total_farm)} DC</div>
				//             </div>
				//             <div className={`${style['place-1']} ${style['top-place']}`}>
				//                 <img className={style['top-place-avatar']} src={`https://dreamcoin.pro/images/users/${leadersList[0]?.user_id}.jpg`}/>
				//                 <img className={style['place']} src={_1st_place}/>
				//                 <div className={style['username']}>{leadersList[0]?.name}</div>
				//                 <div className={style['reward']}>{Math.floor(leadersList[0]?.total_farm)} DC</div>
				//             </div>
				//             <div className={`${style['place-2']} ${style['top-place']}`}>
				//                 <img className={style['top-place-avatar']} src={`https://dreamcoin.pro/images/users/${leadersList[2]?.user_id}.jpg`}/>
				//                 <img className={style['place']} src={_3rd_place}/>
				//                 <div className={style['username']}>{leadersList[2]?.name}</div>
				//                 <div className={style['reward']}>{Math.floor(leadersList[2]?.total_farm)} DC</div>
				//             </div>
				//         </div>
				//     </div>
				//     <div className={style['top']}>
				//         {leadersList.map((element, index) => {
				//             if(index > 2){
				//                 return(
				//                     <LeaderboardUser position={++index} img={`https://dreamcoin.pro/images/users/${element.user_id}.jpg`} name={element.name} reward={Math.floor(element.total_farm)} borderbottom={true} defaultcolor={true}/>
				//                 )
				//             }
				//         })}
				//     </div>
				//     <div className={style['you']}>
				//         <LeaderboardUser position={leaderUser?.month} img={`https://dreamcoin.pro/images/users/${tg.initDataUnsafe.user.id}.jpg`} name={tg.initDataUnsafe.user.first_name} reward={leaderUser?.total_farm_month} bordertop={true} yourcolor={true}/>
				//     </div>
				// </div>
				<></>
			)}
		</>
	);
}
